export default "__VITE_ASSET__DRAIDBqu__"